/** Unicode-safe title case — do not use \\b (ASCII-only; turns Genève → GenÈVe). */
export function toTitleCase(value) {
  return (value || '')
    .toLowerCase()
    .replace(/(^|[^\p{L}])(\p{L})/gu, (_, sep, ch) => `${sep}${ch.toUpperCase()}`);
}
